module.exports = __webpack_public_path__ + "img/assinatura.1889429f.jpeg";